import React from "react";

export default function FlexContainerItem(props) {
  return (
    <div className='flex-container__item'>
      {props.children}
    </div>  
  )
}
